import { useMemo, useState } from 'react';
import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { Box, VStack } from '@cbhq/cds-web/layout';

import { OnrampLogs } from ':cloud/pages/Onramp/OnrampLogs';
import { OnrampMetrics } from ':cloud/pages/Onramp/OnrampMetrics';
import { OnrampOverview } from ':cloud/pages/Onramp/OnrampOverview';
import { Layout } from ':cloud/widgets/layout';
import { MAIN_CONTAINER_MIN_WIDTH } from ':cloud/widgets/product/constants';
import {
  KeyFeatureItem,
  KeyFeaturesSection,
} from ':cloud/widgets/sharedcomponents/KeyFeaturesSection';
import { UnroutedTopNavTabs } from ':cloud/widgets/sharedcomponents/UnroutedTopNavTabs';

const keyFeatures: KeyFeatureItem[] = [
  {
    iconName: 'feesRestriction',
    title: 'Zero fees for USDC',
    description:
      'Make fiat-to-crypto a no-brainer for your users with zero fee onramping for USDC, a stablecoin backed by the US dollar.',
  },
  {
    iconName: 'creditCard',
    title: 'Popular payment types',
    description:
      'Support for preferred payment types like ACH, debit, Apple Pay, and crypto balances. Users without a Coinbase account can buy with a debit card.',
  },
  {
    iconName: 'idVerification',
    title: 'Outsource the details',
    description:
      'Coinbase handles everything from verifying users to storing payment information to fraud claims, so you can focus on building your business.',
  },
  {
    iconName: 'browserMultiPlatform',
    title: 'Integrate quickly',
    description:
      'Our quality documentation takes you through the process step-by-step, so you can integrate quickly and start growing your user base.',
  },
];

export function OnrampLanding() {
  const { isPhone } = useBreakpoints();
  const onrampTabs = useMemo(() => {
    return [
      { id: 'overview', label: 'Overview' },
      { id: 'metrics', label: 'Metrics' },
      { id: 'logs', label: 'Logs' },
    ];
  }, []);

  const [onrampTab, setOnrampTab] = useState(onrampTabs[0].id);

  return (
    <Layout enableMaxWidth={false}>
      <Layout.MainContainer
        minWidth={MAIN_CONTAINER_MIN_WIDTH}
        spacingHorizontal={0}
        spacingTop={0}
        fullWidth
      >
        <Box display="block" width="100%" minWidth="100%">
          <VStack>
            <UnroutedTopNavTabs value={onrampTab} tabs={onrampTabs} onChange={setOnrampTab} />
            <VStack>
              <VStack flexGrow={1} width="100%">
                <VStack spacingTop={8} gap={5}>
                  {onrampTab === 'overview' && <OnrampOverview />}
                  {onrampTab === 'metrics' && <OnrampMetrics />}
                  {onrampTab === 'logs' && <OnrampLogs />}
                  <Box spacingBottom={isPhone ? 10 : 0} spacingHorizontal={1}>
                    <KeyFeaturesSection features={keyFeatures} />
                  </Box>
                </VStack>
              </VStack>
            </VStack>
          </VStack>
        </Box>
      </Layout.MainContainer>
    </Layout>
  );
}
